<template>
  <v-content class="gb">
    <v-container class="fill-width" fluid>
      <v-row align="center" justify="center">
        <v-card :loading="status==='loading' ||  status_service === 'loading'"
                class="fill-width card-theme custom-container display-information">
          <v-row align="center">
            <v-col cols="12" sm="9" class>
              <h2 class="title_info" style="margin-top: 0.75rem; margin-bottom: 1rem">App Profile</h2>
            </v-col>
            <v-col cols="12" sm="3" class="pl-7 text-right">
            </v-col>
          </v-row>
          <v-divider class="divider-margin"></v-divider>
          <v-form class="pt-1 pb-0" autocomplete="off">
            <ValidationObserver ref="obs" v-slot="{}">
              <div class="pt-1">
                <v-row align="center">
                  <v-col cols="6" sm="6" class="pt-1 pb-1">
                    <keep-alive>
                      <ValidationProvider
                          name="companyName"
                          mode="lazy"
                          ref="companyName"
                          rules="required"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            v-model="user.company_name"
                            :error-messages="errors"
                            class="ui-label__width-531 line-height__14 change_bord especial_border support-input custom-input-position-text input-size-16"
                            label="Company Name"
                            name="companyName"
                            type="text"
                            width="660px"
                            required
                        ></v-text-field>
                      </ValidationProvider>
                    </keep-alive>
                  </v-col>
                  <v-col cols="6" sm="3" class="pt-1 pb-1 pl-5">
                    <span class="group pa-2">
                      <keep-alive>
                        <ValidationProvider
                            name="services"
                            mode="lazy"
                            ref="services"
                            rules="required"
                            v-slot="{ errors }"
                        >
                          <!-- Super user: combobox allows typing any custom service name -->
                          <v-combobox
                              v-if="isSuperUser"
                              @keydown="list($event,'grow', user.service)"
                              @change="onServiceChange($event)"
                              v-on:blur="list($event,'blur')"
                              :error-messages="errors"
                              v-model="user.service"
                              :items="services_main"
                              item-text="text"
                              item-value="value"
                              :return-object="false"
                              name="services"
                              required
                              class="ui-label__width-266 line-height__14 change_bord especial_border support-input custom-input-position-text input-size-16 service-field"
                          >
                            <template v-slot:label>
                              <span>Service</span>
                            </template>
                            <template v-slot:append>
                              <img
                                  :src="require('@/assets/img/dropdown-blue-arrow.svg')"
                                  alt
                                  style="position: relative;top: 12px;"
                              />
                            </template>
                            <template v-slot:append-item>
                              <v-list-item
                                  v-on:click="list(null, 'all')"
                                  style="cursor:pointer !important;"
                                  v-show="service_length < 12"
                              >
                                <v-list-item-content>
                                  <v-list-item-title>
                                    More
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-combobox>
                          <!-- Regular vendor: autocomplete only allows selecting from dropdown -->
                          <v-autocomplete
                              v-else
                              @keydown="list($event,'grow', user.service)"
                              @change="onServiceChange($event)"
                              v-on:blur="list($event,'blur')"
                              :error-messages="errors"
                              v-model="user.service"
                              :items="services_main"
                              item-text="text"
                              name="services"
                              required
                              class="ui-label__width-266 line-height__14 change_bord especial_border support-input custom-input-position-text input-size-16 service-field"
                          >
                            <template v-slot:label>
                              <span>Service</span>
                              <v-tooltip top max-width="300">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      style="color: #29abe2; font-size: 16px; margin-left: 4px; vertical-align: middle;"
                                  >info</v-icon>
                                </template>
                                <span>To suggest a new category, email: Support@kiey.com</span>
                              </v-tooltip>
                            </template>
                            <template v-slot:append>
                              <img
                                  :src="require('@/assets/img/dropdown-blue-arrow.svg')"
                                  alt
                                  style="position: relative;top: 12px;"
                              />
                            </template>
                            <template v-slot:append-item>
                              <v-list-item
                                  v-on:click="list(null, 'all')"
                                  style="cursor:pointer !important;"
                                  v-show="service_length < 12"
                              >
                                <v-list-item-content>
                                  <v-list-item-title>
                                    More
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </keep-alive>
                    </span>
                  </v-col>
                  <v-col cols="6" sm="6" class="pt-0">
                    <keep-alive>
                      <ValidationProvider
                          name="firstName"
                          mode="lazy"
                          ref="firstName"
                          rules="required"
                          v-slot="{ errors}"
                      >
                        <v-text-field
                            v-model="user.first_name"
                            :error-messages="errors"
                            class="ui-label__width-531 line-height__14 change_bord especial_border support-input custom-input-position-text input-size-16"
                            label="First Name"
                            name="firstName"
                            type="text"
                            width="660px"
                            required
                        ></v-text-field>
                      </ValidationProvider>
                    </keep-alive>
                  </v-col>
                  <v-col cols="6" sm="6" class="pt-0 pl-5">
                    <keep-alive>
                      <ValidationProvider
                          name="lastName"
                          mode="lazy"
                          ref="lastName"
                          rules="required"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            v-model="user.last_name"
                            :error-messages="errors"
                            class="ui-label__width-527 line-height__14 change_bord especial_border support-input custom-input-position-text input-size-16"
                            label="Last Name"
                            name="lastName"
                            type="text"
                            width="660px"
                            required
                        ></v-text-field>
                      </ValidationProvider>
                    </keep-alive>
                  </v-col>
                  <v-col cols="12" sm="12" class="pt-1">
                    <div v-bind:class="{disabledHashtags: !editInfo}">
                      <div class="header-hashtags">
                        <label class="label line-height__plain-14" :class="{ 'error--text': hashTagError }">Hashtags</label>
                      </div>
                      <tags-input
                          element-id="tags"
                          name="hashTag"
                          v-model="user.selected_tags"
                          :typeahead="true"
                          placeholder=" "
                          type="text"
                          :limit="limit"
                          :add-tags-on-comma="true"
                          :add-tags-on-space="true"
                          @keydown="counter_params"
                          @tag-added="onTagAdded"
                          @tag-removed="onTagRemoved"
                          :before-adding-tag="checkTag"
                          class="c-tags ui-label__width-1092 custom-input-position-text"
                      ></tags-input>
                    </div>
                    <v-text-field
                        :value="hashtagProxyValue"
                        :error-messages="hashTagError ? ['This field is required'] : []"
                        hint="Example: #hvac #roofing #electrical #loan"
                        persistent-hint
                        class="hashtag-proxy-field tag-line-field"
                        readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" class="pt-3">
                    <keep-alive>
                      <ValidationProvider
                          name="tagLine"
                          mode="eager"
                          ref="tagLine"
                          rules="required"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            v-model="user.tag_line"
                            :error-messages="errors"
                            hint="A sentence describing your company"
                            persistent-hint
                            class="tag-line-field line-height__14 change_bord especial_border support-input custom-input-position-text input-size-16"
                            label="Tag Line"
                            name="tagLine"
                            type="text"
                            width="660px"
                            required
                        ></v-text-field>
                      </ValidationProvider>
                    </keep-alive>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <div class="header-hashtags" v-if="editInfo">
                      <label class="label line-height__plain-14">Profile Picture</label>
                    </div>

                    <!-- Edit mode -->
                    <template v-if="editInfo">
                      <!-- Si hay foto -->
                      <v-img
                          v-if="picture"
                          class="profile-picture-preview mt-2"
                          :src="picture"
                      />

                      <!-- Si no hay foto -->
                      <div v-else class="no-picture-message mt-2">
                        Add your profile picture from the setting tab in the Kiey app.
                      </div>
                    </template>

                    <!-- View mode -->
                    <v-img
                        v-else-if="picture"
                        class="profile-picture-preview"
                        :src="picture"
                    />
                  </v-col>

                </v-row>
              </div>
            </ValidationObserver>

          </v-form>
          <div class="text-center">
            <v-btn
                v-if="userSession.user_role !== 'employee'"
                depressed
                rounded
                class="mt-65 btn-azul btn-btn"
                height="48px"
                width="155px"
                :disabled="status==='loading'"
                @click="submit"
                :loading="status==='loading'"
            >SAVE
            </v-btn>
          </div>
        </v-card>
      </v-row>
      <unsaved-modal :show="showUnsavedModal" :hide="hideUnsavedModal" :onSave="saveAndNavigate"/>
      <update-modal :show="showUpdateModal" :hide="hideUpdateModal"/>
    </v-container>
  </v-content>
</template>

<script>
import {ValidationProvider, ValidationObserver} from "vee-validate";
import VoerroTagsInput from "@voerro/vue-tagsinput";
import {mapActions, mapMutations, mapState} from "vuex";
import {uploadFileToStorage} from "@/util/video_utils_v2";
import unsavedModal from "@/views/owner/billing/modals/unsaved";
import updateModal from "@/views/owner/billing/modals/update";

export default {
  name: "AppDisplayInfo",
  async created() {
    if (this.$store.getters["Authenticate/isLoggedIn"]) {
      this.setHideOther(true);
      await this.get_services();
      this.segment_services('all');
      this.segment_services(10);
      this.init();
    } else {
      this.$router.push("/login");
    }
  },
  watch: {
    logged: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.init();
        }
      },
      deep: true
    },
    userSession: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.init(false);
        }
      },
      deep: true
    },
    services_store() {
      this.service_length = this.services_store.length;
      this.services_main = [];
      this.services_main.length = 0;
      if (this.queryText && this.queryText !== "") {
        this.services_main.push(this.queryText)
      }
      for (const prop in this.services_store) {
        this.services_main.push(this.services_store[prop])
      }
    }
  },
  async mounted() {
    await this.$store.dispatch("Display_information/decode");
  },
  beforeRouteLeave(to, from, next) {
    if (this.allowLeave) {
      next();
      return;
    }
    if (this.hasUnsavedChanges()) {
      this.pendingNext = next;
      this.showUnsavedModal = true;
    } else {
      next();
    }
  },
  data: () => ({
    picture: null,
    limit: 0,
    counter: 0,
    editInfo: true,
    imageData: null,
    urlData: null,
    showUnsavedModal: false,
    showUpdateModal: false,
    pendingNext: null,
    allowLeave: false,
    originalValues: {},
    user: {
      first_name: "",
      last_name: "",
      company_name: "",
      service: null,
      selected_tags: [],
      tag_line: "",
      service_other: "",
      profile_picture: "",
    },
    queryText: null,
    service_length: 0,
    services_main: [],
    isCustomService: false,
    hashTagError: false,
    length_hashtags: 0,
    uploadValue: 0,

  }),
  computed: {
    ...mapState({
      status_service: (state) => state.Services.status,
      services_store: (state) => state.Services.slice_services,
      services_complete: (state) => state.Services.services,
      servicesList: state => state.Display_information.services,
      status: state => state.Display_information.status,
      logged: state => state.Display_information.logged,
      userSession: state => state.Authenticate.user,
    }),
    isSuperUser() {
      return this.userSession && this.userSession.user_role === 'super_user';
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "tags-input": VoerroTagsInput,
    "unsaved-modal": unsavedModal,
    "update-modal": updateModal,
  }
  ,
  methods: {
    init(all = true) {
      if (this.logged && all) {
        let service_exists = this.services_complete.find(o => o.value === this.logged.service);
        if (service_exists) {
          if (!this.services_main.find(o => o.value === this.logged.service)) {
            this.queryText = {
              text: this.logged.service,
              value: this.logged.service
            };
            this.services_main.push(this.queryText)
          }
        } else if (this.logged.service) {
          // Vendor signed up with "Other" — add their custom service to the dropdown
          this.queryText = {
            text: this.logged.service,
            value: this.logged.service
          };
          if (!this.services_main.find(o => o.value === this.logged.service)) {
            this.services_main.push(this.queryText);
          }
          // Only super users can type a new custom service name
          if (this.userSession.user_role !== 'super_user') {
            this.isCustomService = true;
          }
        }

        this.user.service = this.logged.service || null;
        this.user.service_other = "";
        this.user.selected_tags = (this.logged.selected_tags) ? this.logged.selected_tags : [];
        this.user.tag_line = (this.logged.tag_line) ? this.logged.tag_line : "";
      }


      this.user.first_name = this.userSession.first_name;
      this.user.last_name = this.userSession.last_name;
      this.user.company_name = this.userSession.company_name;
      this.user.email = this.userSession.email;
      this.user.profile_picture = this.picture = this.userSession.profile_picture;
      this.tenant_id = this.userSession.tenant_id;
      this.user.tenant_id = this.userSession.tenant_id;
      this.user.tenant_user_id = this.userSession.id;
      this.user.owner_id = this.userSession.id;

      this.captureOriginalValues();
    },
    captureOriginalValues() {
      this.originalValues = {
        company_name: this.user.company_name || '',
        first_name: this.user.first_name || '',
        last_name: this.user.last_name || '',
        service: this.user.service || '',
        service_other: this.user.service_other || '',
        tag_line: this.user.tag_line || '',
        selected_tags: JSON.stringify(this.user.selected_tags || []),
      };
    },
    ...mapMutations({
      setHideOther: 'Services/setHideOther',
    }),
    ...mapActions({
      get_services: "Services/get_services",
      segment_services: "Services/segment_services"
    }),
    async saveData() {
      const self = this;
      await this.$store.dispatch("Display_information/update_profile", this.user);
      await self.$store.commit("Authenticate/updateUser", self.user);
      self.picture = self.user.profile_picture;
      self.imageData = null;
    },
    async uploadToStorage() {
      const self = this;
      self.$store.commit("Display_information/loading");
      if (!self.imageData.name) {
        self.imageData.name = new Date().getTime().toString();
      }
      const url = await uploadFileToStorage(self.imageData, 'profile');
      self.picture = url;
      self.urlData = url;
      self.user.profile_picture = url;
      await self.$store.dispatch("Display_information/update_profile", self.user);
      await self.$store.commit("Authenticate/updateUser", self.user);
    },
    onSelectedPicture(file) {
      const self = this;
      self.imageData = file;
      let fr = new FileReader();
      fr.onload = function () {
        self.picture = fr.result;
      };
      fr.onerror = function () {
        self.picture = '';
      };
      fr.readAsDataURL(self.imageData);
    },
    onServiceChange($event) {
      // v-combobox may return an object {text, value} or a raw string — normalize to string
      if ($event && typeof $event === 'object' && $event.value) {
        this.user.service = $event.value;
      }
      // If vendor picks a predefined service, clear the custom service flag
      if (this.isCustomService) {
        const val = (typeof $event === 'object') ? $event.value : $event;
        if (val) {
          const isPredefined = this.services_complete.find(o => o.value === val);
          if (isPredefined) {
            this.isCustomService = false;
          }
        }
      }
      this.list($event, 'reduce');
    },
    async list($event, option, item_service) {
      switch (option) {
        case 'grow':
          if (item_service === undefined) {
            this.segment_services(10);
          } else {
            await this.segment_services("all");
          }
          break;
        case 'reduce':
          this.segment_services(10);

          this.queryText = null;
          if ($event && $event !== "") {
            this.queryText = {
              value: $event,
              text: $event,
            };
          }
          break;
        case 'blur':
          this.segment_services(10);
          break;
        case 'all':
          this.segment_services('all');
          break;
      }
    },
    hasUnsavedChanges() {
      return this.user.company_name !== this.originalValues.company_name ||
          this.user.first_name !== this.originalValues.first_name ||
          this.user.last_name !== this.originalValues.last_name ||
          (this.user.service || '') !== this.originalValues.service ||
          (this.user.service_other || '') !== this.originalValues.service_other ||
          (this.user.tag_line || '') !== this.originalValues.tag_line ||
          JSON.stringify(this.user.selected_tags || []) !== this.originalValues.selected_tags;
    },
    hideUnsavedModal() {
      this.showUnsavedModal = false;
      this.allowLeave = true;
      if (this.pendingNext) {
        this.pendingNext();
        this.pendingNext = null;
      }
    },
    async saveAndNavigate() {
      this.showUnsavedModal = false;
      const saved = await this.submit();
      if (saved) {
        this.allowLeave = true;
        if (this.pendingNext) {
          this.pendingNext();
          this.pendingNext = null;
        }
      }
    },
    hideUpdateModal() {
      this.showUpdateModal = false;
    },
    async submit() {
      const self = this;
      const companyName = await
          this.$refs.companyName.validate();
      const firstName = await
          this.$refs.firstName.validate();
      const lastName = await
          this.$refs.lastName.validate();
      const services = await
          this.$refs.services.validate();
      const tagLine = await
          this.$refs.tagLine.validate();

      // Manual validation for hashtags
      const hashTagValid = this.user.selected_tags && this.user.selected_tags.length > 0;
      this.hashTagError = !hashTagValid;

      if (
          firstName.valid &&
          lastName.valid &&
          companyName.valid &&
          services.valid &&
          hashTagValid &&
          tagLine.valid
      ) {

        if (self.imageData) {
          await self.uploadToStorage();
        } else {
          await self.saveData();
        }

        this.captureOriginalValues();
        this.showUpdateModal = true;
        return true;
      }
      return false;
    },
    checkTag() {
      return true;
    },
    onTagAdded(slug) {
      const self = this;
      self.counter += slug.value.replace("#", "").length;
      self.hashTagError = false;
    },

    onTagRemoved(slug) {
      const self = this;
      self.counter -= slug.value.replace("#", "").length;
    },

    counter_params() {
    },
  }
  ,
}
;
</script>

<style scoped>
.custom-container {
  max-width: 1222px !important;
  min-height: 749px;
  top: 40px;
  margin-bottom: 90px !important;
  padding: 25px 64px;
}

.span_text_label {
  color: #848484;
  font-family: Roboto;
  font-size: 14px;
  line-height: 29px;
  font-style: italic;
  left: 4px;
  position: relative;
}

.label {
  color: #061d47;
  font-size: 16px;
  font-weight: 700;
  line-height: 14px;
  left: -2px;
  position: relative;
  top: -2px;
}

.divider-margin {
  margin-top: -4px;
  margin-bottom: 15px;
  margin-left: 0px !important;
}

.btn-tex {
  color: #2bace2;
  font-size: 13px;
  font-weight: 400;
  width: 158px;
  height: 32px !important;
}

.btn-btn {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.94px;
}

.summary-label {
  color: #061d47;
  font-size: 15.5px;
  margin-top: 1rem;
}

.alert-login-vendor h3 {
  font-size: 22px;
  margin: 3px 0px 0.24rem 13px;
}

.alert-login-vendor p {
  font-size: 14px;
  margin: 0 0 7px 13px;
  letter-spacing: 1.34px;
}

.summary-value {
  color: #3c5fa9;
  font-size: 18px;
}

.p-expansion-login {
  margin-left: 1.5rem;
  font-size: 17.2px;
  line-height: 2.13rem;
}

.padding-payment-inputs {
  padding-bottom: 0.2rem;
}

.link-check {
  color: #29abe2;
  text-decoration: none;
}

.ml-14 {
  margin-left: 56px;
}

.ml-16 {
  margin-left: 64px;
}

.mt-75 {
  margin-top: 101px;
}

.account-information-checkbox {
  position: absolute;
  right: 0;
  top: 1rem;
}

.alert-value-font {
  font-size: 18px;
}

.small-checkbox >>> label {
  font-size: 14px;
}

/* number color to list in modal-box */
li.number-color {
  color: #29abe2;
}

li.number-color > a {
  cursor: default;
}

.service-field ::v-deep .v-label {
  overflow: visible !important;
  pointer-events: auto !important;
}

@media (max-width: 960px) {
  .alert-login-vendor h3 {
    font-size: 16px;
  }

  .alert-login-vendor p {
    font-size: 13px;
  }

  .p-expansion-login {
    margin-left: auto;
    font-size: 12px;
  }

  .ml-14,
  .ml-16 {
    margin-left: auto;
  }
}

@media (max-width: 1400px) {
  .account-information-checkbox {
    position: absolute;
    right: unset;
    top: 2.5rem;
  }
}

/* Tag Line: set the width that ui-label__width-1092 used to provide,
   without inheriting its problematic .v-messages__message overrides */
.tag-line-field {
  max-width: 1092px;
}

/* Hashtag proxy: hide the text input, only show the messages area (error/hint) */
.hashtag-proxy-field >>> .v-input__slot {
  display: none !important;
}
.hashtag-proxy-field {
  margin-top: -2px !important;
  padding-top: 0 !important;
  min-height: 0 !important;
}
.hashtag-proxy-field >>> .v-text-field__details {
  padding-top: 6px;
}
</style>
